import axios from "axios";
import app_config from "app_config";
import store from "lib/store";
import { Template } from "@pdfme/common";


const APIURL = app_config.APIURLV2Base + "sysadmin/report_template";

export interface MReportTemplateListData {
  S: string;
  delete: number;
  name: string;
  storeCycle: string;
  createCycle: string;
  linkedIds: Array<string>;
}

export type MReportTemplateListResponse = Array<MReportTemplateListData>;

interface ReportTemplate {
  S: string;
  delete: number;
  name: string;
  storeCycle: string;
  createCycle: string;
  linkedIds: Array<string>;
}

interface MReportTemplateGetReponse extends ReportTemplate {
  downloadInfo: {url: string;};
}

interface MReportTemplateGetReponse2 extends MReportTemplateGetReponse {
  templateFile: Template;
}

interface MReportTemplateAddRequest {
  sid: string;
  name: string;
  storeCycle: string;
  createCycle: string;
  linkedIds: Array<string>;
}

interface MReportTemplateAddRequest2 extends MReportTemplateAddRequest {
  templateFile: Template;
}

interface MReportTemplateUpdateRequest {
  name?: string;
  storeCycle?: string;
  createCycle?: string;
  linkedIds?: Array<string>;
}

interface MReportTemplateAddUpdateResponse {
  S: string;
  uploadInfo: {
    url: string;
    fields: {[key: string]: string};
  };
}

interface MReportTemplateAddUpdateResponse2 {
  S: string;
}

interface MReportTemplateUpdateRequest2 extends MReportTemplateUpdateRequest {
  templateFile?: Template;
}

interface MReportTemplateDeleteResponse {
}

/**
 * SysAdmin Report Template API
 */
export class MReportTemplateAPI {
  static async list(signal?: AbortSignal) {
    const res = await axios.get<MReportTemplateListResponse>(
      APIURL,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    return res.data;
  }

  static async add(data: MReportTemplateAddRequest2, signal?: AbortSignal): Promise<MReportTemplateAddUpdateResponse2> {
    const reportData: MReportTemplateAddRequest = {
      sid: data.sid,
      name: data.name,
      storeCycle: data.storeCycle,
      createCycle: data.createCycle,
      linkedIds: data.linkedIds,
    };

    // update report template information
    const res = await axios.post<MReportTemplateAddUpdateResponse>(
      APIURL,
      reportData,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    // テンプレートファイルのアップロード
    if (data.templateFile) {
      const formData = new FormData();

      Object.keys(res.data.uploadInfo.fields).forEach((key) => {
        formData.append(key, res.data.uploadInfo.fields[key]);
      });
  
      const blob = new Blob([JSON.stringify(data.templateFile)], {
        type: 'application/json',
      });
      formData.append("file", blob);
  
      await axios.post(
        res.data.uploadInfo.url,
        formData,
        {
          signal: signal,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    return {
      S: res.data.S
    };
  }

  static async get(id: string, signal?: AbortSignal): Promise<MReportTemplateGetReponse2> {
    // get report template information
    const res = await axios.get<MReportTemplateGetReponse>(
      APIURL + "/" + id,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    // download report template file from s3
    const resfile = await axios.get(res.data.downloadInfo.url, {
      signal: signal,
    });

    return {...res.data, templateFile: resfile.data};
  }

  static async update(id: string, data: MReportTemplateUpdateRequest2, signal?: AbortSignal): Promise<MReportTemplateAddUpdateResponse2> {
    const reportData: MReportTemplateUpdateRequest = {
      name: data.name,
      storeCycle: data.storeCycle,
      createCycle: data.createCycle,
      linkedIds: data.linkedIds,
    };

    // update report template information
    const res = await axios.post<MReportTemplateAddUpdateResponse>(
      APIURL + "/" + id,
      reportData,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    // テンプレートファイルのアップロード
    if (data.templateFile) {
      const formData = new FormData();

      Object.keys(res.data.uploadInfo.fields).forEach((key) => {
        formData.append(key, res.data.uploadInfo.fields[key]);
      });
  
      const blob = new Blob([JSON.stringify(data.templateFile)], {
        type: 'application/json',
      });
      formData.append("file", blob);
  
      await axios.post(
        res.data.uploadInfo.url,
        formData,
        {
          signal: signal,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    return {
      S: res.data.S
    };
  }


  static async delete(id: string, signal?: AbortSignal): Promise<MReportTemplateDeleteResponse> {
    const res = await axios.delete(
      APIURL + "/" + id,
      {
        signal: signal,
        headers: {
          "Authorization": store.getState().appState.session
        },
      }
    );

    return res;
  }
}
